import React, {Component} from 'react'
import {toJS} from 'mobx'
import {inject, observer} from 'mobx-react'
import {getPaginationConfig} from '../../../components/pagination'
import {PAGE_SIZE_DEFAULT} from '../../../constants/appConstant'
import {Table} from 'antd'
import {withTranslation} from 'react-i18next'
import history from '../../../routes/history'
const storage = window.localStorage

@inject('marketingSmsManagementStore', 'accountStore')
@observer
class SearchResult extends Component {
  state = {
    columns: []
  }
  componentDidMount() {
    const {marketingSmsManagementStore, accountStore, sourceType, t} = this.props
    const { generateID } = marketingSmsManagementStore
    const {accountInfos} = accountStore
    const infos = JSON.parse(storage.getItem('accountInfos'))
    marketingSmsManagementStore.onPhoneAction({
      'sourceType': sourceType,
      'phone': '',
      'taskGroupId': generateID,
      'isPowerUser' : accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser,
      'page': 1,
      'size': PAGE_SIZE_DEFAULT
    })
    marketingSmsManagementStore.onGetStatus('sourceType')
    this.setState({
      defaultColumns: [
        {
          title: t(`marketingManagement.phone`),
          dataIndex: 'phone',
          key: 'phone',
          editable: true,
        },
      ]
    })
  }
  handlePageChange = (page, pageSize) => {
    const {marketingSmsManagementStore} = this.props
    marketingSmsManagementStore.onChangePersonalPhonePageNumAction(page, pageSize)
  }
  getRowClassName = (record, index) => {
    let className = ''
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }
  render() {
    const {marketingSmsManagementStore, t} = this.props
    const {pageNoPersonalPhone, pageSizePersonalPhone, itemCountPersonalPhone, viewList} = marketingSmsManagementStore
    const pagination = getPaginationConfig(pageNoPersonalPhone, pageSizePersonalPhone, itemCountPersonalPhone, this.handlePageChange)
    return (
      <>
        <Table 
          className="searchResult" 
          dataSource={toJS(viewList)} 
          pagination={pagination} 
          rowKey="id" 
          rowClassName={this.getRowClassName} 
          style={{marginTop: 0, padding: 0}}
          columns={this.columns}
        >
          {/* <Table.Column width={100} title='ID' dataIndex="id" key="id" ellipsis={true} render={(text, record, index) => 
            index+1
          } /> */}
          <Table.Column width={150} title={t(`marketingManagement.phoneTit`)} dataIndex="phone" key="phone" ellipsis={true}/>
          <Table.Column title={t(`marketingManagement.content`)} dataIndex="content" key="content" ellipsis={true}/>
          <Table.Column width={100} title={t(`marketingManagement.wordsSum`)} dataIndex="characterNum" key="characterNum" ellipsis={true}/>
          <Table.Column width={100} title={t(`marketingManagement.num`)} dataIndex="smsNum" key="smsNum" ellipsis={true}/>
        </Table>
      </>
    )
  }
}

export default withTranslation()(SearchResult)
